import React, { useState, useEffect } from "react";
import Swatch from "./Swatch";
import ColorChart from "./ColorChart.js";
import WalrusComp from "./PatternSVGComponents/WalrusComp";
import CrabComp from "./PatternSVGComponents/CrabComp";
import { PICS } from "./images";
import "./PatternSwatches.css";
import PatternSelect from "./PatternSelect";
import { isMobile } from "react-device-detect";

// import Color from "color-thief-react";

const PatternSwatches = ({ isMobile }) => {
  const [swatches, setSwatches] = useState(PICS);
  const [element, setElement] = useState([]);
  const [elementName, setElementName] = useState("");
  const [pattern, setPattern] = useState("");
  const [height, setHeight] = useState(false);

  const PatternMap = {
    "Brendan the Crab": CrabComp,
    "Wally the Walrus": WalrusComp,
  };

  const handleSelectPattern = (pattern) => {
    setPattern(pattern[0]);
  };

  const selectSwatch = (code, color) => {
    let elArray = pattern.elements;
    const elIndex = elArray.findIndex((el) => el.part === elementName);

    const newPatObj = {
      ...pattern.elements[elIndex],
      newCode: code,
      newColor: color,
    };

    elArray[elIndex] = newPatObj;

    let newPattern = { ...pattern };
    newPattern.elements[elIndex] = newPatObj;
    setPattern(newPattern);
    updatePattern(color);
  };

  const updatePattern = (color) => {
    for (let i = 0; i < element.length; i++) {
      element[i].setAttribute("fill", color);
    }
  };

  const changeColor = (evt) => {
    const els = document.getElementsByClassName(evt.target.id);
    setElement(els);
    setElementName(evt.target.id);
    console.log(evt.target.fill);
  };

  const sortedSwatches = swatches.sort(
    (a, b) => parseInt(a.id) - parseInt(b.id)
  );

  const pageDisplay = sortedSwatches.map((pic) => (
    <div className="patternSwatches" key={pic.id}>
      {/* <Color src={pic.url} format="hex">
        {
          ({ data, loading, error }) =>
            // return (
            console.log("id: " + pic.id + " data " + data)
          // <div style={{backgroundColor: data, width: "40px", height: "40px", fontSize: "8px"}}>
          //   {data}
          // </div>
          // )
        }
      </Color> */}

      <Swatch
        draggable
        key={pic.id}
        id={pic.id}
        url={pic.url}
        isMobile={isMobile}
        swatchColor={pic.swatchhex}
        inPalette={false}
        selectSwatch={selectSwatch}
      />
    </div>
  ));

  let Component;

  if (pattern) {
    Component = PatternMap[pattern.title];
  }

  // useEffect(() => {
  //   const handleWindowResize = () => setHeight(window.innerHeight);
  //   window.addEventListener("resize", handleWindowResize);

  //   return () => window.removeEventListener("resize", handleWindowResize);
  // }, []);

  return (
    <div className="patternSwatchesContainer">
      <div
        className={pattern ? "selectorAndPhotoWithPattern" : "selectorAndPhoto"}
      >
        <PatternSelect handleSelectPattern={handleSelectPattern} />
        <div className="photoContainer">
          <img
            src="BrendanTheHermitCrab2.jpg"
            className="patternPhoto"
            alt="pattern character"
          />
        </div>
      </div>

      {pattern ? (
        <div className="pictureChart">
          <div className="svgDisplay">
            <Component changeColor={changeColor} />
          </div>
          <ColorChart pattern={pattern} elementName={elementName} />
        </div>
      ) : null}

      <div className="patternSwatchPics">{pageDisplay}</div>
    </div>
  );
};

export default PatternSwatches;
